export default __webpack_public_path__ + "static/media/no_coupon.a029e801.png";